// extracted by mini-css-extract-plugin
export default {"title":"create_title__XWE72","container":"create_container__JSD90","header":"create_header__Yz+q3"};